"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6872],{

/***/ 56872:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ MainSlider_MainSlider; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-responsive-carousel/lib/js/index.js
var js = __webpack_require__(10615);
// EXTERNAL MODULE: ./node_modules/react-responsive-carousel/lib/styles/carousel.min.css
var carousel_min = __webpack_require__(12755);
;// CONCATENATED MODULE: ./src/blocks/MainSlider/icons.tsx


const arrowIcon = /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "27.669",
    height: "13.402",
    viewBox: "0 0 27.669 13.402",
    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
        transform: "translate(27.669 145.402) rotate(180)",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
            transform: "translate(0 132)",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                className: "slider-control-arrow",
                d: "M27.352,137.936h0l-5.647-5.62a1.081,1.081,0,0,0-1.525,1.532l3.792,3.773H1.081a1.081,1.081,0,1,0,0,2.162H23.97l-3.792,3.773a1.081,1.081,0,0,0,1.525,1.532l5.647-5.62h0A1.082,1.082,0,0,0,27.352,137.936Z",
                transform: "translate(0 -132)"
            })
        })
    })
});

// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
;// CONCATENATED MODULE: ./src/blocks/MainSlider/positionMapper.ts
const getFlexPosition = (position)=>{
    switch(position){
        case "top":
            return "flex-start";
        case "bottom":
            return "flex-end";
        case "center":
            return "center";
        default:
            return "center";
    }
};

// EXTERNAL MODULE: ./src/components/Picture/index.ts + 1 modules
var Picture = __webpack_require__(17856);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 12 modules
var esm = __webpack_require__(30674);
// EXTERNAL MODULE: ./utils/validators.ts
var validators = __webpack_require__(44624);
// EXTERNAL MODULE: ./utils/icons.tsx
var icons = __webpack_require__(42108);
;// CONCATENATED MODULE: ./src/blocks/MainSlider/components/SlideItem.tsx








const SlideItem = (param)=>{
    let { allSlides , slideIndex , currentSlide , tiles , position , hasBottomPadding , lang  } = param;
    const [linkedSlideIndex, setLinkedSlideIndex] = (0,react.useState)(null);
    const [activeTile, setActiveTile] = (0,react.useState)();
    const { t  } = (0,esm/* useTranslation */.$G)();
    const setDefaultSelected = ()=>{
        const activeTileIndex = tiles.findIndex((tile)=>tile.selected);
        if (activeTileIndex !== -1) {
            setActiveTile(activeTileIndex);
            const linkedSlide = (0,lodash.get)(tiles[activeTileIndex], "linked_slide");
            setLinkedSlideIndex(linkedSlide);
        }
    };
    const styleForSlideContent = {
        paddingBottom: hasBottomPadding ? "115px" : 0,
        paddingTop: hasBottomPadding ? "115px" : 0,
        justifyContent: getFlexPosition(position)
    };
    (0,react.useEffect)(()=>{
        setDefaultSelected();
    }, []);
    const onMouseEnter = (linkedSlideNumber, index)=>{
        if (linkedSlideNumber) {
            setLinkedSlideIndex(linkedSlideNumber);
        }
        setActiveTile(index);
    };
    const onMouseLeave = ()=>{
        const defaultActiveTileIndex = tiles.findIndex((tile)=>tile.selected);
        if (defaultActiveTileIndex !== -1) {
            setLinkedSlideIndex(tiles[defaultActiveTileIndex].linked_slide);
        } else if (linkedSlideIndex) {
            setLinkedSlideIndex(null);
        }
        setActiveTile(defaultActiveTileIndex !== -1 ? defaultActiveTileIndex : undefined);
    };
    const getTilesForSlide = ()=>{
        return tiles.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "cards",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "cardsContainer",
                children: tiles.map((slideTile, index)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        onMouseEnter: ()=>onMouseEnter(slideTile.linked_slide, index),
                        onMouseLeave: onMouseLeave,
                        className: "slider-card".concat(activeTile === index ? " slider-card--active" : ""),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "slider-card__title ".concat(slideTile.picture ? "" : "slider-card__withoutImg"),
                                children: [
                                    slideTile.picture && slideTile.picture.publicUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)(Picture/* default */.Z, {
                                        data: slideTile.picture
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                        children: slideTile.title
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "slider-card__description",
                                children: slideTile.content
                            }),
                            slideTile.link && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "slider-card__action",
                                children: (0,validators/* isFullUrl */.AU)(slideTile.link) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                    href: slideTile.link,
                                    className: "modern-button modern-button-outline-secondary modern-button-small",
                                    children: [
                                        t("packages-block-more"),
                                        " ",
                                        icons/* chevronRight */.EI
                                    ]
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                    href: "/".concat(lang).concat(slideTile.link),
                                    className: "modern-button modern-button-outline-secondary modern-button-small",
                                    children: [
                                        t("packages-block-more"),
                                        " ",
                                        icons/* chevronRight */.EI
                                    ]
                                })
                            })
                        ]
                    }, slideTile.title))
            })
        }) : null;
    };
    const getLinkedSlideData = ()=>{
        if (typeof activeTile === "number") {
            const currentTile = tiles[activeTile];
            if (currentTile && typeof currentTile.linked_slide === "number") {
                const linkedSlide = allSlides[currentTile.linked_slide - 1];
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Picture/* default */.Z, {
                            data: linkedSlide.picture
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "slide__content",
                            style: {
                                display: linkedSlideIndex ? "flex" : "none"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "slide__contentContainer",
                                style: styleForSlideContent,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    dangerouslySetInnerHTML: {
                                        __html: linkedSlide.content
                                    }
                                })
                            })
                        })
                    ]
                });
            }
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "main-slider__slide",
        children: [
            !linkedSlideIndex && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Picture/* default */.Z, {
                        data: currentSlide.picture
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "slide__content",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "slide__contentContainer",
                            style: styleForSlideContent,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                dangerouslySetInnerHTML: {
                                    __html: currentSlide.content
                                }
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: !linkedSlideIndex ? "slide-fadeOut_animation" : "slide-fadeIn_animation",
                children: getLinkedSlideData()
            }),
            getTilesForSlide()
        ]
    }, "slide_".concat(slideIndex));
};
/* harmony default export */ var components_SlideItem = (SlideItem);

// EXTERNAL MODULE: ./node_modules/react-media/esm/react-media.js
var react_media = __webpack_require__(87784);
// EXTERNAL MODULE: ./node_modules/mobile-device-detect/dist/index.js
var dist = __webpack_require__(85088);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./src/blocks/MainSlider/MainSlider.tsx










const MainSlider = (param)=>{
    let { blockData  } = param;
    const { locale: lang  } = (0,router.useRouter)();
    const { data: { element ={} , tiles ={} , positionDesktop , positionMobile , delay  }  } = blockData;
    const slides = Object.values(element);
    const tilesForSlides = Object.values(tiles);
    const hasOnlyOneSlide = slides.length === 1;
    const renderArrowNext = (clickHandler, hasNext)=>{
        const classNameForButton = "slider-control-arrow-button next".concat(hasNext ? "" : " disabled");
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
            "aria-label": "Next slide",
            className: classNameForButton,
            onClick: clickHandler,
            children: arrowIcon
        });
    };
    const renderArrowPrev = (clickHandler, hasNext)=>{
        const classNameForButton = "slider-control-arrow-button prev".concat(hasNext ? "" : " disabled");
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
            "aria-label": "Previous slide",
            className: classNameForButton,
            onClick: clickHandler,
            children: arrowIcon
        });
    };
    const getTilesForSlide = (slidePosition)=>tilesForSlides.filter((tile)=>tile.parent_slide === slidePosition);
    const getSlidesForCarouselDesktop = ()=>slides.map((slide, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(components_SlideItem, {
                allSlides: slides,
                currentSlide: slide,
                slideIndex: index,
                tiles: getTilesForSlide(index + 1),
                position: positionDesktop,
                hasBottomPadding: !!tilesForSlides.length && tilesForSlides.length > 0,
                lang: lang
            }, "slide_".concat(index)));
    const getSlidesForCarouselMobile = ()=>{
        return slides.map((slide, slideIndex)=>{
            /*#__PURE__*/ return (0,jsx_runtime.jsx)(react_media/* default */.Z, {
                query: "(orientation: landscape)",
                defaultMatches: false,
                children: (matches)=>{
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                        className: "main-slider__slide",
                        style: {
                            backgroundImage: "url(".concat("https://www-api.coderslabkosova.com/" + (matches ? slide === null || slide === void 0 ? void 0 : slide.picture.publicUrl : slide.picture_mobile ? slide.picture_mobile.publicUrl : slide.picture.publicUrl), ")"),
                            backgroundSize: "cover"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "slide__content slide__content--mobile",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "slide__contentContainer slide__contentContainer--mobile",
                                style: {
                                    justifyContent: getFlexPosition(positionMobile)
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    dangerouslySetInnerHTML: {
                                        __html: slide.content
                                    }
                                })
                            })
                        })
                    });
                }
            }, "slide_".concat(slideIndex));
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "main-slider",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_media/* default */.Z, {
                query: "(min-width: 768px)",
                defaultMatches: !dist.isMobile,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(js/* Carousel */.lr, {
                    className: "main-slider__desktop",
                    showArrows: true,
                    showThumbs: false,
                    stopOnHover: true,
                    autoPlay: !!delay && delay > 0,
                    interval: delay,
                    showIndicators: false,
                    infiniteLoop: !hasOnlyOneSlide,
                    showStatus: false,
                    dynamicHeight: true,
                    renderArrowNext: renderArrowNext,
                    renderArrowPrev: renderArrowPrev,
                    children: getSlidesForCarouselDesktop()
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_media/* default */.Z, {
                query: "(max-width: 767px)",
                defaultMatches: dist.isMobile,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(js/* Carousel */.lr, {
                    className: "main-slider__mobile",
                    showArrows: false,
                    showThumbs: false,
                    stopOnHover: true,
                    autoPlay: !!delay && delay > 0,
                    interval: delay,
                    showIndicators: !hasOnlyOneSlide,
                    infiniteLoop: !hasOnlyOneSlide,
                    showStatus: false,
                    swipeScrollTolerance: 100,
                    preventMovementUntilSwipeScrollTolerance: true,
                    children: getSlidesForCarouselMobile()
                })
            })
        ]
    });
};
/* harmony default export */ var MainSlider_MainSlider = (MainSlider);

;// CONCATENATED MODULE: ./src/blocks/MainSlider/index.ts



/***/ })

}]);